const en_master_sales = {
    "": "Sales",
    add: "Add Sales",
    edit: "Edit Sales",

    label: {
        coa: "Commission Payable COA Code",
    },

    error: {
        create: "Failed to create sales",
        edit: "Failed to update sales",
        delete: "Failed to delete sales",
        user: "User is required.",
    },

    success: {
        create: "Sales created successfully",
        edit: "Sales updated successfully",
        delete: "Sales deleted successfully",
    },
}

export default en_master_sales;